// Novidades da versão no CRM: o que o clube vê ao clicar na versão do rodapé.
// Regras puras (testadas): quais novidades aparecem para quem está usando e como
// agrupam por dia de publicação (dia civil de São Paulo, IR-TZ-006).
// Doc: docs/funcionalidades/novidades-da-versao.md
import { diaSP } from "@pps/datas-sp";

export interface NovidadeDoClube {
  chave: string;
  titulo: string;
  texto: string;
  /** Instante da 1ª publicação NESTE ambiente. */
  publicada_em: string;
  versao: string;
  flag: string | null;
}

export interface DiaDeNovidades {
  /** 'yyyy-MM-dd' em São Paulo. */
  dia: string;
  itens: NovidadeDoClube[];
}

/**
 * Novidade atrás de flag só aparece para quem tem a flag ligada — senão o clube leria
 * sobre uma tela que não tem. Sem flag, aparece para todos. Falha fechada: flag que não
 * veio do servidor conta como desligada.
 */
export function novidadesVisiveis(
  itens: readonly NovidadeDoClube[],
  flags: Readonly<Record<string, boolean>>,
): NovidadeDoClube[] {
  return itens.filter((n) => !n.flag || flags[n.flag] === true);
}

/** Agrupa por dia de publicação, do mais novo para o mais antigo, mantendo a ordem dentro do dia. */
export function agruparPorDia(itens: readonly NovidadeDoClube[]): DiaDeNovidades[] {
  const grupos = new Map<string, NovidadeDoClube[]>();
  for (const n of itens) {
    const dia = diaSP(n.publicada_em);
    const lista = grupos.get(dia);
    if (lista) lista.push(n);
    else grupos.set(dia, [n]);
  }
  return [...grupos.entries()]
    .sort(([a], [b]) => (a < b ? 1 : a > b ? -1 : 0))
    .map(([dia, lista]) => ({ dia, itens: lista }));
}
